import * as Actions from '../../actions/reports/type';

const initialState = {
  loading: false,
  mechanicReports: '',
  error: '',

  getAllOrderReportsLoading: false,
  getAllOrderReports: '',
  getAllOrderReportsError: false,

  saleSummaryReportsLoading: false,
  saleSummaryReports: '',
  saleSummaryReportsError: false,

  getHeaderLoading: false,
  headerMatrices: [],
  headerMatricesError: '',

  getFirstTableLoading: false,
  firstTable: [],
  firstTableErr: '',

  getSecondTableLoading: false,
  secondTable: [],
  secondTableErr: '',
  saleSummaryLoading: false,
  saleSummary: [],
  saleSummaryErr: '',

  allPaymentLoading: false,
  allPaymentReport: [],
  allPaymentTotals: [],
  allPaymentReportErr: '',

  paymentSummaryLoading: false,
  paymentSummaryReport: [],
  paymentSummaryTotalAmount: 0,
  paymentSummaryReportErr: '',

  accountReceivableLoading: false,
  acountReceivablereport: [],
  acountReceivableTotals: 0,
  acountReceivableReportErr: '',
  accountRecievableGrandTotal: 0,
  accountRecievableTotalRemaining: 0,
  accountRecievableCreditCardFee: 0,
  accountRecievableSupplyFee: 0,
};

export const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Generate Mechanic Reports

    case Actions.GENERATE_MECHANIC_REPORTS_REQUEST:
      return { ...state, loading: true };

    case Actions.GENERATE_MECHANIC_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        mechanicReports: action.payload?.data || '',
      };
    case Actions.GENERATE_MECHANIC_REPORTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Mechanic Reports

    case Actions.GET_MECHANIC_REPORTS_REQUEST:
      return { ...state, loading: true };

    case Actions.GET_MECHANIC_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        // mechanicReports: action.payload?.data || '',
      };
    case Actions.GET_MECHANIC_REPORTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get All Order Reports

    case Actions.GET_ALL_ORDER_REPORTS_REQUEST:
      return { ...state, getAllOrderReportsLoading: true };

    case Actions.GET_ALL_ORDER_REPORTS_SUCCESS:
      return {
        ...state,
        getAllOrderReportsLoading: false,
        getAllOrderReports: action.payload?.data || '',
      };
    case Actions.GET_ALL_ORDER_REPORTS_FAIL:
      return {
        ...state,
        getAllOrderReportsLoading: false,
        getAllOrderReportsError: action.payload,
      };
    case Actions.CLEAR_ALL_ORDER_REPORTS_STATES:
      return {
        ...state,
        getAllOrderReportsLoading: false,
        getAllOrderReports: '',
        getAllOrderReportsError: false,
      };

    // Get Sale Summary Reports

    case Actions.GET_SALE_SUMMARY_REPORTS_REQUEST:
      return {
        ...state,
        saleSummaryReportsLoading: true,
      };

    case Actions.GET_SALE_SUMMARY_REPORTS_SUCCESS:
      return {
        ...state,
        saleSummaryReportsLoading: false,
        saleSummaryReports: action.payload?.data || '',
      };
    case Actions.GET_SALE_SUMMARY_REPORTS_FAIL:
      return {
        ...state,
        saleSummaryReportsLoading: false,
        saleSummaryReportsError: action.payload,
      };
    case Actions.CLEAR_SALE_SUMMARY_REPORTS_STATES:
      return {
        ...state,
        saleSummaryReportsLoading: false,
        saleSummaryReports: '',
        saleSummaryReportsError: false,
      };
    // ==================Day End Report ==============
    // get header matrices

    case Actions.GET_HEADER_MATRICES_REQUEST:
      return {
        ...state,
        getHeaderLoading: true,
      };

    case Actions.GET_HEADER_MATRICES_SUCCESS:
      return {
        ...state,
        getHeaderLoading: false,
        headerMatrices: action.payload?.data || '',
      };
    case Actions.GET_HEADER_MATRICES_FAIL:
      return {
        ...state,
        getHeaderLoading: false,
        headerMatricesError: action.payload,
      };
    // get Day End First Table

    case Actions.GET_DAY_END_FIRST_TABLE_REQUEST:
      return {
        ...state,
        getFirstTableLoading: true,
      };

    case Actions.GET_DAY_END_FIRST_TABLE_SUCCESS:
      return {
        ...state,
        getFirstTableLoading: false,
        firstTable: action.payload?.data || '',
      };
    case Actions.GET_DAY_END_FIRST_TABLE_FAIL:
      return {
        ...state,
        getFirstTableLoading: false,
        firstTableErr: action.payload,
      };
    // get Day End Second Table

    case Actions.GET_DAY_END_SECOND_TABLE_REQUEST:
      return {
        ...state,
        getSecondTableLoading: true,
      };

    case Actions.GET_DAY_END_SECOND_TABLE_SUCCESS:
      return {
        ...state,
        getSecondTableLoading: false,
        secondTable: action.payload?.data || '',
      };
    case Actions.GET_DAY_END_SECOND_TABLE_FAIL:
      return {
        ...state,
        getSecondTableLoading: false,
        secondTableErr: action.payload,
      };

    // ======== get Sale Summary Report=======

    case Actions.GET_SALE_SUMMARY_REPORT_REQUEST:
      return {
        ...state,
        saleSummaryLoading: true,
      };

    case Actions.GET_SALE_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        saleSummaryLoading: false,
        saleSummary: action.payload?.data || '',
      };
    case Actions.GET_SALE_SUMMARY_REPORT_FAIL:
      return {
        ...state,
        saleSummaryLoading: false,
        saleSummaryErr: action.payload,
      };

    // ======== get All Payment Report=======

    case Actions.GET_ALL_PAYMENT_REPORT_REQUEST:
      return {
        ...state,
        allPaymentLoading: true,
      };

    case Actions.GET_ALL_PAYMENT_REPORT_SUCCESS:
      return {
        ...state,
        allPaymentLoading: false,
        allPaymentReport: action.payload?.data || '',
        allPaymentTotals: action.payload?.totalsData || '',
      };
    case Actions.GET_ALL_PAYMENT_REPORT_FAIL:
      return {
        ...state,
        allPaymentLoading: false,
        allPaymentReportErr: action.payload,
      };

    // ======== get Payment Summary Report=======

    case Actions.GET_PAYMENT_SUMMARY_REPORT_REQUEST:
      return {
        ...state,
        paymentSummaryLoading: true,
      };

    case Actions.GET_PAYMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        paymentSummaryLoading: false,
        paymentSummaryReport: action.payload?.data || '',
        paymentSummaryTotalAmount: action.payload?.data?.totalAmount || '',
      };
    case Actions.GET_PAYMENT_SUMMARY_REPORT_FAIL:
      return {
        ...state,
        paymentSummaryLoading: false,
        paymentSummaryReportErr: action.payload,
      };

    case Actions.GET_ACCOUNT_RECIEVABLE_REPORT_REQUEST:
      return {
        ...state,
        accountReceivableLoading: true,
      };

    case Actions.GET_ACCOUNT_RECIEVABLE_REPORT_SUCCESS:
      return {
        ...state,
        accountReceivableLoading: false,
        acountReceivablereport: action.payload?.data || '',
        acountReceivableTotals: action.payload?.totalsData[0]?.totalRows || '',
        accountRecievableGrandTotal:
          action.payload?.totalsData[0]?.grandTotal || '',
        accountRecievableTotalRemaining:
          action.payload?.totalsData[0]?.totalRemainingAmount || '',
        accountRecievableCreditCardFee:
          action.payload?.totalsData[0]?.calculatedCreditCardFee || '',
        accountRecievableSupplyFee:
          action.payload?.totalsData[0]?.calculatedSupplyFee || '',
      };
    case Actions.GET_ACCOUNT_RECIEVABLE_REPORT_FAIL:
      return {
        ...state,
        accountReceivableLoading: false,
        acountReceivableReportErr: action.payload,
      };

    default:
      return state;
  }
};
